import { createFileRoute } from '@tanstack/react-router'
import EmpreendimentoDetailPage from '@/pages/empreendimentos/empreendimento-detail'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

// Rota index para /dashboard/$dashboardId/empreendimentos/$empreendimentoId
// Renderizada quando acessar diretamente /dashboard/$dashboardId/empreendimentos/$empreendimentoId
// Sem rota filha ativa
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/empreendimentos/$empreendimentoId/',
)({
  component: function EmpreendimentoDetailRoute() {
    const { dashboardId, empreendimentoId } = Route.useParams()
    return (
      <RequireModule module={MODULES.EMPREENDIMENTOS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_IMOB_DATA}>
          <EmpreendimentoDetailPage
            empreendimentoId={empreendimentoId}
            dashboardId={dashboardId}
          />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
